import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesCreateDescriptionControllerModule } from './controllers/TemplatesCreateDescriptionController';

export const TemplatesCreateDescriptionView = angular
  .module('acme.view.application.templates.create.description', [
    uiRouter,
    'ui.bootstrap',
    TemplatesCreateDescriptionControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.templates.create.description',
      url: '/description',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateDescriptionController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/description/description.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Event Template',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.description',
      url: '/description',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateDescriptionController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/description/description.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template',
      },
    });
  }).name;
